import {getDevicesCatalogPending, getDevicesCatalogSuccess, getDevicesCatalogError} from './index';
import config from '../../oktaConfig';

function getDevicesCatalog(accessToken) {
  return dispatch => {
    dispatch(getDevicesCatalogPending());

    fetch(config.resourceServer.insightsApiUrlDevices, {
      mode: 'cors',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          const error = new Error(
            `Unable to retrieve devices catalog: ${response.status} ${response.statusText}`
          );
          error.status = response.status;
          error.statusText = response.statusText;
          error.response = response;
          return Promise.reject(error);
        }
        return response.json();
      })
      .then(data => {
        dispatch(getDevicesCatalogSuccess(data));
      })
      .catch(err => {
        dispatch(getDevicesCatalogError(err));
        /* eslint-disable no-console */
        console.error('Unable to retrieve devices catalog', err);
      });
  };
}

export default getDevicesCatalog;
